import { Form, InputNumber } from 'antd'
import { FC } from 'react'
import formatIntegerBySpace from '../../../../../../../../../../helpers/formatters/format-integer-by-space'

interface ApproximateCostProps {}

const ApproximateCost: FC<ApproximateCostProps> = () => {
    const name = 'approximateCost'

    return (
        <Form.Item name={name} label={'Предварительная стоимость'}>
            <InputNumber formatter={formatIntegerBySpace} />
        </Form.Item>
    )
}

export default ApproximateCost
